import { Auth } from '@angular/fire/auth';
import { useQuery } from '@tanstack/react-query';
import { auth } from '@core/utils/firebase/firebase';
import { createSitesApi } from '../api/sites.api';
import type { Site } from '@core/interfaces/api';

const sitesApi = createSitesApi(auth as Auth);

export function useSitesByOrgQuery({
  organizationId,
  enabled = true,
}: {
  organizationId?: number | null;
  enabled?: boolean;
}) {
  return useQuery<Site[]>({
    queryKey: ['sites-by-org', organizationId],
    enabled: enabled && !!organizationId,
    queryFn: async () => {
      if (!organizationId) {
        return [];
      }

      return sitesApi.getSitesByOrgId(organizationId.toString());
    },
  });
}
